module.exports = __webpack_public_path__ + "static/media/close.5dbc17f1.svg";